// SSR stub for @lobehub/icons — renders placeholder spans
function IconStub(props: any) {
  return <span style={{ display: 'inline-block', width: '1em', height: '1em' }} {...props} />
}

// Named AI provider icons used in neo components
export const Claude = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export const OpenAI = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export const Perplexity = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export const Grok = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export const Windsurf = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export const Cursor = { Color: IconStub, Text: IconStub, Combined: IconStub, Mono: IconStub, Avatar: IconStub }
export default IconStub
